import axios from "axios";
import router from "../router";
import store from "../store";
import {
  UPDATE_LOADING,
  UPDATE_TOKEN,
  UPDATE_USERINFO
} from "../store/modules/consts";
import Cookies from "js-cookie";

let startTime = 0;

function checkLoginInterval() {
  let currentDate = new Date().getTime();
  if (currentDate - startTime > 10 * 1000) {
    startTime = currentDate;
    // gotoLogin(baseAuth);
    return true;
  } else {
    return false;
  }
}

// 创建axios实例
const service = axios.create({
  baseURL:
    process.env.NODE_ENV === "production"
      ? process.env.BASE_API
      : process.env.BASE_API, // api的base_url
  // : 'http://test-mall.900sup.com/api-server/', // api的base_url
  timeout: 10000, // 请求超时时间
  headers: {
    appType: 1
  }
});

// request拦截器
service.interceptors.request.use(
  // request => request,
  request => {
    // 不显示loading
    if (request.headers.loading !== false) {
      store.commit(UPDATE_LOADING, true);
    }

    if (Cookies.get(UPDATE_TOKEN)) {
      // 判断是否存在token，如果存在的话，则每个http header都加上token
      request.headers.apiUserToken = `${store.getters.token}`;
    } else {
      request.headers.apiUserToken = "";
    }

    // console.log("拦截request ======= " + request.url);
    // console.log(request);
    return request;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// respone拦截器
service.interceptors.response.use(
  response => {
    // console.log(response);

    store.commit(UPDATE_LOADING, false);

    if (response.data && response.data.code === -1) {
      console.log("拦截response登录失效");
      if (checkLoginInterval()) {
        console.warn("###跳转重新授权");
        let userCookies = Cookies.get(UPDATE_USERINFO);
        if (userCookies) {
          let userInfo = JSON.parse(userCookies);
          let _thisUrl = window.location.pathname + window.location.search;
          router.push({
            path: "/auth",
            query: {
              BusinessID: userInfo.BusinessID,
              Data: userInfo.Data,
              BackUrl: _thisUrl
            }
          });
        } else {
          router.push({ path: "/logout" });
        }
      } else {
        console.warn("###正在重新授权中...");
      }
    }

    return response;
  },
  error => {
    store.commit(UPDATE_LOADING, false);

    console.log("err" + error);
    return Promise.reject(error);
  }
);
export default service;



// WEBPACK FOOTER //
// ./src/utils/fetch.js